<template>
  <div class="video-wrapper">
    <div v-if="videoId">
      <iframe
        :src="`https://www.youtube.com/embed/${videoId}?origin=${origin}&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`"
        allowfullscreen
        allow="autoplay"
      ></iframe>
    </div>
    <div
      v-else
      class="video-placeholder-invalido"
    >
      Link de vídeo inválido
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});

const origin = window.location.origin;

function extractYoutubeId(url) {
  if (!url) return null;

  const patterns = [
    /(?:youtube\.com\/watch\?v=)([^&]+)/,
    /(?:youtube\.com\/embed\/)([^?]+)/,
    /(?:youtu\.be\/)([^?]+)/,
    /(?:youtube\.com\/shorts\/)([^?]+)/,
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return match[1];
  }

  return null;
}

const videoId = computed(() => extractYoutubeId(props.url));
</script>

<style scoped>
.video-wrapper {
  width: 100%;
  max-width: 400px;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.video-wrapper > div {
  width: 100%;
  height: 100%;
}

.video-wrapper > div > iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.video-placeholder-invalido {
  width: 100%;
  height: 100%;
  background-color: var(--cinza-escuro);
  color: var(--cinza-medio);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  border-radius: 8px;
}
</style>
